import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './pages/HomePage';
import Contact from './pages/Contact';
import Architecture from './pages/Architecture';
import Furniture from './pages/Furniture';
import FurnitureItem from './pages/FurnitureItem';
import Art from './pages/Art';
import ArtProject from './pages/ArtProject';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import SingleItem from './pages/SingleItem';
import Login from './pages/Admin/Login';
import Dashboard from './pages/Admin/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import Register from './pages/Admin/Register';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/architecture" element={<Architecture />} />
        <Route path="/architecture/:id" element={<SingleItem />} />
        <Route path="/furniture" element={<Furniture />} />
        <Route path="/furniture/:id" element={<FurnitureItem />} />
        <Route path="/art" element={<Art />} />
        <Route path="/art/:id" element={<ArtProject />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:id" element={<ProductDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:id" element={<EventDetail />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/register" element={<Register />} />
        <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
};

export default App;